import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=2112d5e2&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=2112d5e2&lang=scss&scoped=true&"
import style1 from "./personal.vue?vue&type=style&index=1&id=2112d5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112d5e2",
  null
  
)

export default component.exports